import React, { useEffect, useState, useRef } from 'react';

import backgroundImageX1 from '../../../../images/cars-page/cars-l1-image@1x.webp';
import backgroundImageX2 from '../../../../images/cars-page/cars-l1-image@2x.webp';
import getIsMobile from '../../../utils/isMobile';

import Classes from './PageBackground.scss';

const PageBackground = () => {
  const nodeRef = useRef<any>(null);
  const [isMobile, setIsMobile] = useState<boolean | undefined>();

  useEffect(() => {
    setIsMobile(getIsMobile());
  }, []);

  if (isMobile || typeof isMobile === 'undefined') {
    return null;
  }

  return (
    <div className={Classes.root}>
      <img alt="" src={backgroundImageX1} ref={nodeRef} srcSet={`${backgroundImageX1} 1x, ${backgroundImageX2} 2x`} />
    </div>
  );
};

export default PageBackground;
